import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { QuoteProvider } from "./context/QuoteContext";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ContactPage from "./pages/ContactPage";
import FAQsPage from "./pages/FAQsPage";
import GalleryPage from "./pages/GalleryPage";
import CareersPage from "./pages/CareersPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import MidlandPage from "./pages/MidlandPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
};

// Legacy URL redirects -> preserve link equity from the original WordPress site.
// The original basinplumbing.com used flat URLs (no /services or /blog prefix).
// These keep existing rankings/backlinks from 404ing after the migration.
const legacyRedirects = {
  "/waterline-replacement": "/services/waterline-replacement",
  "/gas-line-replacement-midland-odessa-texas": "/services/gas-line-replacement-midland-odessa-texas",
  "/sewer-line-replacement": "/services/sewer-line-replacement",
  "/drain-cleaning-midland-odessa-texas": "/services/drain-cleaning-midland-odessa-texas",
  "/drain-cleaning-services": "/blog/drain-cleaning-services",
  "/water-heater-installation-replacement-repair-midland-odessa-texas": "/services/water-heater-installation-replacement-repair-midland-odessa-texas",
  "/water-heater-replacement-cost-odessa-midland-tx": "/blog/water-heater-replacement-cost-odessa-midland-tx",
  "/trenchless-plumbing": "/services/trenchless-plumbing",
  "/plumbing-trenchless": "/services/trenchless-plumbing",
  "/pipe-bursting": "/blog/pipe-bursting",
  "/medical-gas-installation": "/services/medical-gas-installation",
  "/medical-gas-installer": "/services/medical-gas-installation",
  "/residential-plumbing": "/services/residential-plumbing",
  "/ac-drain-line-cleaner": "/blog/ac-drain-line-cleaner",
  "/how-much-does-it-cost-to-replace-a-water-heater": "/blog/how-much-does-it-cost-to-replace-a-water-heater",
  "/signs-water-heater-needs-replacement": "/blog/signs-water-heater-needs-replacement",
  "/tankless-vs-tank-water-heaters-west-texas": "/blog/tankless-vs-tank-water-heaters",
  "/what-is-trenchless-plumbing": "/blog/what-is-trenchless-plumbing",
  "/emergency-plumbing-service": "/blog/emergency-plumber-odessa-midland",
  // Phase 1 SEO Audit: Redirect indexed but non-existent pages
  "/widget-test": "/contact",
  "/widget-test/": "/contact",
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <QuoteProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/plumbers-in-midland" element={<MidlandPage />} />

            {/* Legacy URL redirects for link-equity preservation */}
            {Object.entries(legacyRedirects).map(([from, to]) => (
              <Route key={from} path={from} element={<Navigate to={to} replace />} />
            ))}
          </Routes>
        </QuoteProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
